import React from 'react'
import Account from '../components/Account/Account'
import About from '../components/About/About'
import VerifyEmail from '../components/EmailVerify/EmailVerify'
import EmailSent from '../components/EmailVerify/EmailSent'

const EmailSentPage = () => {
  return (
    <div>
        <EmailSent />
    </div>
  )
}

export default EmailSentPage